import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getAllRole = async () => {
  const url = endpoints.VIEW_LIST_ROLE;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const createRole = async (params: any) => {
  const url = endpoints.VIEW_LIST_ROLE;

  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const updateRole = async (params: any) => {
  const url = endpoints.VIEW_LIST_ROLE;

  const { data: response } = await axios.put(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const deleteRole = async (id: number) => {
  const url = endpoints.VIEW_LIST_ROLE + "/" + id;

  const { data: response } = await axios.delete(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const roleService = {
  getAllRole,
  createRole,
  updateRole,
  deleteRole
};

export default roleService;
